(function () {
  const rootSelector = 'store-header';
  const templateSelector = 'template[data-bodycare-deferred-media]';

  function hydrate(scope) {
    scope.querySelectorAll(templateSelector).forEach((template) => {
      template.replaceWith(template.content.cloneNode(true));
    });
  }

  function init(root = document) {
    const headers = root.matches?.(rootSelector) ? [root] : root.querySelectorAll?.(rootSelector) || [];
    headers.forEach((header) => {
      if (header.dataset.bodycareDeferredMediaReady === 'true') return;
      header.dataset.bodycareDeferredMediaReady = 'true';

      const onIntent = (event) => {
        const menu = event.target.closest?.('details');
        if (menu && header.contains(menu)) hydrate(menu);
      };

      header.addEventListener('pointerover', onIntent, { passive: true });
      header.addEventListener('focusin', onIntent);
      header.addEventListener('click', onIntent);
      header.addEventListener('toggle', (event) => {
        if (event.target.open) hydrate(event.target);
      }, true);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
